export default __webpack_public_path__ + "static/media/logo-merkator-potecializando-2023.23b84dd2.svg";